import { Helmet } from "react-helmet";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Customer from "./Customer";
import Baner from "./Baner";
import HomeService from "./HomeService";
import Project from "./Project";
import Certificate from "./Certificate";
import OtherService from "./OtherService";
import GalleryHome from "./GalleryHome";

export default function Home() {
  const { t } = useTranslation();
  const { lang: langParam } = useParams();
  const location = useLocation();

  // زبان از URL (حتی اگر Home بیرون از Route :lang باشد)
  const seg = location.pathname.split("/")[1];
  const lang = langParam || (seg === "fa" || seg === "en" ? seg : "en");

  return (
    <>
      <Helmet>
        <title>{t("home.seo.title")}</title>
        <meta name="description" content={t("home.seo.description")} />
        <meta name="keywords" content={t("home.seo.keywords")} />
        <link
          rel="alternate"
          hrefLang="fa"
          href={`${window.location.origin}/fa`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`${window.location.origin}/en`}
        />
      </Helmet>

      {/* سکشن‌ها خودشون dir رو تنظیم می‌کنند؛ اگر خواستی کل صفحه هم جهت بگیره: */}
      <div dir={lang === "en" ? "ltr" : "rtl"}>
        <Baner />
        <HomeService />
        <Project />
        <GalleryHome />
        <OtherService />
        <Certificate />
        <Customer />
        {/* اگر ProjectMade لازم است اینجا بیار 
        <ProjectMade />*/}
      </div>
    </>
  );
}
